import { request } from "utils/api";

export function index(step = 1) {
  return request(`/study_plans/${step}`, { method: "GET" });
}

export function get(step: number, topic: string) {
  let path = `/study_plans/${step}`;
  if (topic) path += `/${topic}`;
  return request(path, { method: "GET" });
}

export function create(attributes: any) {
  return request("/study_plans", { method: "POST", body: attributes });
}

export function update(attributes: any) {
  return request("/study_plans", { method: "PATCH", body: attributes });
}

export function destroy() {
  return request("/study_plans", { method: "DELETE" });
}
